import http from "@/shared/services/http";

export const listCreditCustomer = (params: any) =>  http.get(`v1/debt-customers`,  { params });
export const allCreditCustomer = (params: any) =>  http.get(`v1/debt-customers/all`,  { params });
export const expenseCustomer = (data: any) =>  http.post(`v1/revenue-expenditures/customer`, data);